import { isLoginFunc, isLoginOtpFunc } from "../store/slices/login"

export const errorMsgs = (code: number, api: any) => {
    switch (code) {
        /* case 400:
            return "Kullanıcı adı veya şifreniz hatalı" */
        case 401:
            api.dispatch(isLoginFunc(false))
            localStorage.removeItem("accessToken")
            return 'Yetkisiz erişim. Lütfen giriş yapınız.'
        case 403:
            return 'Bu işlemi gerçekleştirme yetkiniz yok.'
        case 423:
            return 'Çok sayıda hatalı giriş sebebiyle hesabınız geçici olarak kilitlendi.'
        case 429:
            return 'Bildirim gönderme limitini aştınız. Lütfen daha sonra tekrar deneyin.'
        case 409:
            api.dispatch(isLoginFunc(false))
            api.dispatch(isLoginOtpFunc(true))
            return 'Şifrenizin süresi doldu. Lütfen şifrenizi yenileyiniz.'
        case 500:
            return 'Sunucu hatası. Lütfen daha sonra tekrar deneyiniz.'
        case 0:
            return 'CORS hatası. Lütfen sunucu yapılandırmanızı kontrol ediniz.'
        default:
            return 'Bir hata oluştu. Lütfen tekrar deneyiniz.'
    }
}

